import type {EditRepresentativeContactFormPayload} from "./edit-representative-contact.schema";

import {editRepresentativeContact} from "@project/sdk/sales";
import {EditRepresentativeContactBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

import {editRepresentativeContactMapper} from "./edit-representative-contact.mapper";

export function editRepresentativeContactMutationOptions(
  representativeId: string,
  contactId: number,
) {
  return mutationOptions({
    mutationKey: representativeMutationKeys.editRepresentativeContact,
    mutationFn: (formPayload: EditRepresentativeContactFormPayload) => {
      const request = EditRepresentativeContactBody.parse(
        editRepresentativeContactMapper.toSdk(formPayload),
      );

      return editRepresentativeContact(representativeId, contactId, request);
    },
    onSuccess: async (_result, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
